var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LazyHydrate',{attrs:{"never":""}},[(_vm.content)?_c('article',{staticClass:"production-news-block"},[_c('div',{staticClass:"production-news-block__timeline mt-4 ms-2",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }